import { Box, css, keyframes, styled } from '@withjoy/joykit';

const shimmerKeyframes = keyframes`
  0% {
    transform: translateX(-150%);
  }
  100% {
    transform: translateX(150%);
  }
`;

const shimmerMixin = css`
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 40%,
      rgba(255, 255, 255, 0.9) 50%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0) 100%
    );
    pointer-events: none;
    opacity: 1;
    animation: ${shimmerKeyframes} var(--shimmer-duration, 2500ms) linear infinite;
    will-change: transform;
    transition: opacity 200ms ease-in-out;
  }

  @media (prefers-reduced-motion: reduce) {
    &::before {
      animation: none;
    }
  }
`;

export const ShimmerContainer = styled(Box)<{ enabled: boolean; durationMs: number }>`
  --shimmer-duration: ${props => props.durationMs}ms;
  ${props => props.enabled && shimmerMixin};
`;
